import { TrackingMetaData } from '../../domains/CustomSection'
import GenericContent from '../../domains/GenericContent'

export interface TrackingDetails {
  trackingId: string
  contentContainerType?: string
  contentContainerName?: string
  id?: string
  genericContents?: GenericContent[]
  elementPosition?: number
  displayTitle?: string
  trackingMetaData?: TrackingMetaData
}

class TrackingEvent extends Event {
  static readonly TRACKING_EVENT_TYPE = 'QUINCE_TRACKING'
  static readonly TRACKING_BROWSER_EVENT_TYPES = {
    CLICK: 'CLICK',
    VISIBLE: 'VISIBLE',
  } as const
  readonly tracking_details: TrackingDetails
  readonly trackingEventType: (typeof TrackingEvent.TRACKING_BROWSER_EVENT_TYPES)[keyof typeof TrackingEvent.TRACKING_BROWSER_EVENT_TYPES]
  readonly trackingIds: string[] = []

  constructor(
    eventType: (typeof TrackingEvent.TRACKING_BROWSER_EVENT_TYPES)[keyof typeof TrackingEvent.TRACKING_BROWSER_EVENT_TYPES],
    tracking_details: TrackingDetails,
  ) {
    super(TrackingEvent.TRACKING_EVENT_TYPE, {
      bubbles: true,
    })
    this.trackingEventType = eventType
    this.tracking_details = tracking_details
    this.trackingIds.push(tracking_details.trackingId)
  }

  pushTrackingId(trackingId: string) {
    if (this.tracking_details.trackingId !== trackingId) {
      this.trackingIds.push(trackingId)
    }
  }
}

export type TrackingBrowserEventTypes =
  (typeof TrackingEvent.TRACKING_BROWSER_EVENT_TYPES)[keyof typeof TrackingEvent.TRACKING_BROWSER_EVENT_TYPES]

export default TrackingEvent
